{
  "categoryCard": {
    "dropdown": {
      "translationButton": "Se översättningar",
      "editButton": "Redigera",
      "deleteButton": "Ta bort"
    },
    "questionsCount": "{{questionCount}} frågor",
    "noQuestions": "Inga frågor än",
    "exploreQuestionsButton": "Utforska andra frågor",
    "addQuestionsButton": "Lägg till frågor",
    "lastAskedText": "Senast frågad",
    "notAskedText": "Inte frågad än",
    "satisfactionScoreText": "Nöjdhetspoäng"
  },
  "teamPerformanceCard": {
    "comparedToAverage": {
      "more": "mer än företagets genomsnitt",
      "less": "mindre än företagets genomsnitt",
      "same": "samma som företagets genomsnitt"
    },
    "companyBaseline": "Företagets baslinje {{score}}",
    "notEnoughResponses": "Inte tillräckligt med svar"
  },
  "insightsCard": {
    "responseCount": "{{responseCount}} svar"
  },
  "integrationCard": {
    "status": {
      "connected": {
        "verified": "Verifierad",
        "configured": "Konfigurerad",
        "connected": "Ansluten",
        "managed": "Hanterad"
      },
      "notConnected": {
        "verify": "Verifiera",
        "configure": "Konfigurera",
        "connect": "Anslut",
        "manage": "Hantera"
      }
    }
  },
  "questionHistoryRow": {
    "responseCount_one": "{{formattedResponses}} svar",
    "responseCount_other": "{{formattedResponses}} svar",
    "insufficientResponses": "Otillräckliga svar",
    "questionButton": "Se detaljer"
  },
  "manageCategoryPopup": {
    "title": "Steg 1/2",
    "buttonNewCategory": "Lägg till ny kategori",
    "buttonEditCategory": "Redigera kategori",
    "changeButton": "Byt ikon",
    "nextStep": "Nästa steg",
    "cancelButton": "Avbryt",
    "inputs": {
      "categoryPlaceholder": "Ange kategorinamn",
      "categoryLabel": "Kategori namn",
      "descriptionPlaceholder": "Ange beskrivning",
      "descriptionLabel": "Beskrivning"
    }
  },
  "iconPickerCategoryPopup": {
    "buttons": {
      "backButton": "Gå tillbaka",
      "choseIconButton": "Välj ikon för kategori"
    },
    "categories": {
      "performance": "Prestanda",
      "communication": "Kommunikation",
      "teamCulture": "Teamkultur",
      "learning": "Lärande"
    }
  },
  "translationOverviewCategory": {
    "title": "Steg 2/2",
    "description": "Kontrollera översättning till andra språk",
    "subtitle": "Vi använder AI-översättning, så resultatet kan innehålla fel",
    "buttons": {
      "backButton": "Gå tillbaka",
      "buttonNewCategory": "Lägg till kategori",
      "buttonEditCategory": "Redigera kategori"
    },
    "categoryNameText": "Kategorinamn",
    "descriptionText": "Beskrivning"
  },
  "changeQuestionPopup": {
    "title": "Ändra fråga",
    "buttons": {
      "cancelButton": "Avbryt",
      "changeButton": "Ändra fråga"
    },
    "inputs": {
      "labelCategory": "Kategori",
      "placeholderCategory": "Välj kategori",
      "labelQuestion": "Fråga",
      "placeholderQuestion": "Välj fråga"
    },
    "questionHistory": {
      "lastAskedHint": "Senast frågad {{date}}",
      "empty": "(Tom)"
    },
    "errors": {
      "updateFailed": "Det gick inte att uppdatera schemalagd fråga. Försök igen."
    }
  },
  "blocksSidebar": {
    "placeholder": "Sök block",
    "filters": {
      "all": "Alla",
      "text": "Text",
      "numbers": "Siffror",
      "graphs": "Grafer"
    }
  },
  "dashboardSidebar": {
    "role": "Roll",
    "profileSettings": "Profilinställningar",
    "signOut": "Logga ut",
    "powered": "Drivs av"
  },
  "changeIndicator": {
    "noChange": "Ingen ändring"
  },
  "categoryDistributionCard": {
    "questionsCount_one": "{{count}} fråga",
    "questionsCount_other": "{{count}} frågor"
  },
  "gaugeChart": {
    "enpsScore": "eNPS-poäng"
  },
  "pieChartSimple": {
    "previously": "{{companyScore}} % tidigare",
    "companyBaseline": "Företagsbaslinje:"
  },
  "tagList": {
    "noTags": "Inga taggar"
  },
  "surveyCard": {
    "dropdown": {
      "edit": "Redigera",
      "delete": "Ta bort"
    },
    "useTemplate": "Använd mall",
    "preview": "Förhandsgranska"
  },
  "translationOverviewQuestion": {
    "questionNameText": "Frågens namn"
  },
  "calendar": {
    "cancel": "Avbryt",
    "apply": "Verkställ"
  },
  "categoryPopup": {
    "translationEditItem": {
      "title": "Redigera översättning",
      "cancel": "Avbryt",
      "save": "Spara ändringar"
    }
  },
  "shareReportPopup": {
    "title": "Dela rapport",
    "accessReport": "Åtkomst till rapport",
    "anyoneWithLink": "Alla med länken",
    "copyLink": "Kopiera länk"
  },
  "surveyBuilderPopup": {
    "surveyInfoPopup": {
      "title": "Redigera översättning",
      "tags": "Taggar",
      "cancel": "Avbryt",
      "save": "Spara ändringar"
    },
    "surveyPublishPopup": {
      "title": "Publicera en enkät",
      "surveyTitle": "Enkättitel",
      "surveyDescription": "Enkätbeskrivning",
      "tags": "Taggar",
      "audienceSize": "Publikstorlek",
      "startDate": "Startdatum",
      "distributionMethods": "Distributionsmetoder",
      "cancel": "Avbryt",
      "save": "Spara ändringar"
    },
    "surveyQuestionPopup": {
      "title": "Redigera översättning",
      "options": "Alternativ",
      "cancel": "Avbryt",
      "save": "Spara ändringar"
    }
  },
  "userManagementRow": {
    "seeDetails": "Visa detaljer",
    "leaderTag": "Leader",
    "roleChangeNotAllowed": "Endast administratörer kan ändra användarroller."
  },
  "errorScreen": {
    "notFound": {
      "title": "Sidan hittades inte",
      "description": "Det verkar som att den har sidan har flyttats eller inte langre finns. Vi hjalper dig tillbaka - ga till Oversikt eller ga tillbaka till foregaende sida.",
      "secondaryCta": "Ga till foregaende sida",
      "primaryCta": "Ga till Oversikt"
    },
    "generic": {
      "title": "Nagot gick inte som forvantat",
      "description": "Vi arbetar redan med att aterstalla allt. Forsok igen, eller ga tillbaka for att fortsatta dar allt fungerar som det ska.",
      "secondaryCta": "Forsok igen",
      "primaryCta": "Ga tillbaka"
    }
  },
  "deliveryPausedBanner": {
    "title": "Utskick av frågor är pausat",
    "description": {
      "manual": "Ditt frågeutskick är för närvarande pausat. Kontakta supporten för mer information.",
      "subscription_canceled": "Din prenumeration har avslutats och frågeutskicket har stoppats. Kontakta supporten för att återaktivera det.",
      "subscription_past_due": "Vi kunde inte behandla din betalning. Frågeutskicket är pausat tills betalningen har uppdaterats.",
      "subscription_unpaid": "Din betalning är försenad och frågeutskicket har stängts av. Kontakta supporten för att lösa detta.",
      "subscription_paused": "Din prenumeration är pausad och frågeutskicket är pausat. Kontakta supporten för att återuppta det."
    },
    "contactSupport": "Kontakta supporten"
  },
  "globalBanner": {
    "dismissFailed": "Ditt val kunde inte sparas. Försök igen."
  },
  "setupIncompleteBanner": {
    "title": "Slutför konfigurationen för att börja få feedback",
    "description": "Ställ in din organisation för att börja samla in teaminsikter. Det tar mindre än 15 minuter.",
    "completeSetupMessage": "Slutför konfiguration"
  }
}
